import { TableauSettingsService } from "@vm/tableau";

import { ConfigSource } from "./config-source";

type Listener<T> = <K extends keyof T>(key: K, value: T[K]) => void;

export class TableauSettingsConfigSource<T> implements ConfigSource<T> {
  name = "TableauSettingsConfigSource";

  tableauSettings: TableauSettingsService;
  settings: Record<string, unknown> = {};

  private changeListeners: Listener<T>[] = [];

  constructor(readonly priority = 100) {
    this.tableauSettings = new TableauSettingsService();

    this.tableauSettings.addListener((settings) => {
      this.settings = settings;
      this.handleSettingsChanged();
    });
  }
  public async getAllConfigValues(): Promise<T> {
    return this.settings as T;
  }

  public async getConfigValue<K extends keyof T>(
    key: K,
  ): Promise<T[K] | undefined> {
    return this.settings[key as string] as T[K];
  }

  public listenForChanges<K extends keyof T>(
    callback: (key: K, value: T[K]) => void,
  ): void {
    this.changeListeners.push(callback as Listener<T>);
  }

  private handleSettingsChanged(): void {
    // Notify listeners of each changed key
    Object.keys(this.settings).forEach((key) => {
      const value = this.settings[key] as T[keyof T];
      this.changeListeners.forEach((listener) =>
        listener(key as keyof T, value),
      );
    });
  }

  public async initialize(): Promise<void> {
    this.settings = await this.tableauSettings.getAllSettings();
  }
}
